function mobileMenu() {
    const burger = document.querySelector('.burger')
    if(burger) {
        const BURGER_SRC = '/wp-content/themes/admiral/components/burger/img/burger.png'
        const BURGER_CLOSE_SRC = '/wp-content/themes/admiral/components/burger/img/close.png'
        const headerMenu = document.querySelector('.header_menu')
        const navbar = document.querySelector('.navbar')
        const heightMenu = navbar.offsetHeight+20
        burger.addEventListener('click', ()=>{
            if(headerMenu.classList.contains('active_menu')) {
                headerMenu.classList.remove('active_menu')
                burger.src = BURGER_SRC
                headerMenu.style.height = 0+'px'
            } else {
                headerMenu.classList.add('active_menu')
                burger.src = BURGER_CLOSE_SRC
                headerMenu.style.height = heightMenu+'px'
            }
        })
    }
}
export default mobileMenu